module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">审核</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>是否审核通过？</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok(2)\">是</button>\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">否</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/user/modal/review.html
// module id = 159
// module chunks = 0